<!--
  @Description: 
  @Author: wang.y 
  @Date: 2025-07-23 
-->
<template>
  <div class="header" id="home-header">
    <div class="header-content">
      <div class="header-left">
        <div class="header-logo" @click="handleChangeRoute('index')">
          <img :src="static_img_url+'pic/logo.png?v=' + $store.state.imgVersion" />
        </div>
        <!-- <div class="header-str">
          <p class="p1">{{'中国·苏州' | dealLanguage('SUZHOU·CHINA')}}</p>
          <p class="p2">{{activityDetail.startTime | time_moment('YYYY.M.D')}}-{{activityDetail.endTime | time_moment('YYYY.M.D')}}</p>
        </div> -->
      </div>
      <div :class="['header-navigation',language]">
        <!-- <div :class="['nav-item']" @click="handleChangeRoute('asgct')">
          <span>{{'ASGCT考察团' | dealLanguage('ASGCT Vip Delegation')}}</span>
        </div> -->
        <Dropdown @on-visible-change="handleChangeVisible($event, '关于CSGCT')" @on-click="handleChangeRoute">
          <div :class="['nav-item', visible['关于CSGCT'] && 'visible']">
            <span>{{'关于CSGCT' | dealLanguage('About CSGCT')}}</span>
            <i class="iconfont">&#xe669;</i>
          </div>
          <DropdownMenu slot="list">
            <DropdownItem :name="'contentPage' + item.id" v-for="item,index in navPosition([284, 285, 297])" :key="index">{{item.pageTitle | dealLanguage(item.enPageTitle)}}</DropdownItem>
          </DropdownMenu>
        </Dropdown>
        <Dropdown @on-visible-change="handleChangeVisible($event, '大会会议')" @on-click="handleChangeRoute">
          <div :class="['nav-item', visible['大会会议'] && 'visible']">
            <span>{{'大会会议' | dealLanguage('Annual Meeting')}}</span>
            <i class="iconfont">&#xe669;</i>
          </div>
          <DropdownMenu slot="list">
            <DropdownItem name="theme">{{'会议日程' | dealLanguage('Scientific Program')}}</DropdownItem>
            <DropdownItem name="guests">{{'会议嘉宾' | dealLanguage('Featured Speakers')}}</DropdownItem>
            <DropdownItem name="previousMeetings">{{'往届大会' | dealLanguage('Previous Meetings')}}</DropdownItem>
          </DropdownMenu>
        </Dropdown>
        <Dropdown @on-visible-change="handleChangeVisible($event, '大会活动')" @on-click="handleChangeRoute">
          <div :class="['nav-item', visible['大会活动'] && 'visible']">
            <span>{{'大会活动' | dealLanguage('Conference Activities')}}</span>
            <i class="iconfont">&#xe669;</i>
          </div>
          <DropdownMenu slot="list">
            <DropdownItem :name="'contentPage' + item.id" v-for="item,index in navPosition([286, 287, 288])" :key="`1_${index}`">{{item.pageTitle | dealLanguage(item.enPageTitle)}}</DropdownItem>
            <!-- <DropdownItem name="innovationAwards">{{'CSGCT创新之星奖项' | dealLanguage('CSGCT Innnovation Awards')}}</DropdownItem> -->
            <DropdownItem :name="'contentPage' + item.id" v-for="item,index in navPosition([290])" :key="`2_${index}`">{{item.pageTitle | dealLanguage(item.enPageTitle)}}</DropdownItem>
          </DropdownMenu>
        </Dropdown>
        <div :class="['nav-item']" v-for="item,index in navPosition([291])" :key="index" @click="handleChangeRoute('contentPage' + item.id)">
          <span>{{item.pageTitle | dealLanguage(item.enPageTitle)}}</span>
        </div>
        <Dropdown @on-visible-change="handleChangeVisible($event, '注册参会')" @on-click="handleChangeRoute">
          <div :class="['nav-item', visible['注册参会'] && 'visible']">
            <span>{{'注册参会' | dealLanguage('Registration')}}</span>
            <i class="iconfont">&#xe669;</i>
          </div>
          <DropdownMenu slot="list">
            <DropdownItem name="signUp">{{'大会注册' | dealLanguage('Register Now')}}</DropdownItem>
            <DropdownItem :name="'contentPage' + item.id" v-for="item,index in navPosition([292])" :key="index">{{item.pageTitle | dealLanguage(item.enPageTitle)}}</DropdownItem>
          </DropdownMenu>
        </Dropdown>
        <Dropdown @on-visible-change="handleChangeVisible($event, '展览赞助')" @on-click="handleChangeRoute">
          <div :class="['nav-item', visible['展览赞助'] && 'visible']">
            <span>{{'展览赞助' | dealLanguage('Sponsor & Exhibit')}}</span>
            <i class="iconfont">&#xe669;</i>
          </div>
          <DropdownMenu slot="list">
            <DropdownItem :name="'contentPage' + item.id" v-for="item,index in navPosition([293])" :key="index">{{item.pageTitle | dealLanguage(item.enPageTitle)}}</DropdownItem>
            <DropdownItem name="compReg">{{'成为赞助商' | dealLanguage('Become a Sponsor')}}</DropdownItem>
          </DropdownMenu>
        </Dropdown>
        <Dropdown @on-visible-change="handleChangeVisible($event, '日常活动')" @on-click="handleChangeRoute">
          <div :class="['nav-item', visible['日常活动'] && 'visible']">
            <span>{{'日常活动' | dealLanguage('CSGCT Programs')}}</span>
            <i class="iconfont">&#xe669;</i>
          </div>
          <DropdownMenu slot="list">
            <DropdownItem :name="'contentPage' + item.id" v-for="item,index in navPosition([294, 295, 296])" :key="index">{{item.pageTitle | dealLanguage(item.enPageTitle)}}</DropdownItem>
          </DropdownMenu>
        </Dropdown>
        <div :class="['nav-item']" @click="handleChangeRoute('newsList')">
          <span>{{'新闻动态' | dealLanguage('News')}}</span>
        </div>
        <div :class="['nav-item']" v-if="!user_key" @click="handleChangeRoute('login')">
          <span>{{'登录' | dealLanguage('Sign In')}}</span>
        </div>
        <Dropdown @on-visible-change="handleChangeVisible($event, '用户中心')" @on-click="handleChangeRoute" v-else>
          <div :class="['nav-item', visible['用户中心'] && 'visible']">
            <span>{{'用户中心' | dealLanguage('USER CENTER')}}</span>
          </div>
          <DropdownMenu slot="list">
            <DropdownItem name="userInfo">{{'个人信息' | dealLanguage('Personal center')}}</DropdownItem>
            <DropdownItem name="myTickets">{{'我的门票' | dealLanguage('My Tickets')}}</DropdownItem>
            <DropdownItem name="orderList">{{'订单和发票' | dealLanguage('Orders and Invoices')}}</DropdownItem>
            <DropdownItem name="contributionList">{{'已提交摘要' | dealLanguage('My Abstracts')}}</DropdownItem>
            <!-- <DropdownItem name="companions">{{'同行人' | dealLanguage('Companion')}}</DropdownItem> -->
            <DropdownItem name="quit"><span style="color: #FF0000">{{'退出登录' | dealLanguage('Log out')}}</span></DropdownItem>
          </DropdownMenu>
        </Dropdown>

        <div :class="['lang-item']" @click="handleChangeLanguage" v-if="$route.name != 'newsDetail'">
          <span :class="[language == 'zh' && 'active']">中</span>
          <span>/</span>
          <span :class="[language == 'en' && 'active']">EN</span>
        </div>
      </div>
    </div>
    <template v-if="channelDiscountRate < 1 && $route.name == 'signUp'">
      <div class="hero-overlay" v-if="language == 'en'">Get {{channelDiscountRate | discountShow}} tickets exclusively.</div>
      <div class="hero-overlay" v-else>当前购票享受{{channelDiscountRate | discountShowZh}}优惠</div>
    </template>
    <template v-if="asgctDiscountRate < 1 && $route.name == 'asgct'">
      <div class="hero-overlay" v-if="language == 'en'">Get {{asgctDiscountRate | discountShow}} tickets exclusively.</div>
      <div class="hero-overlay" v-else>当前购票享受{{asgctDiscountRate | discountShowZh}}优惠</div>
    </template>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { Aexitlogin } from '@/service/app'
import filter from 'js/filter'
export default {
  inject: ['globalInsertRecords', 'login', 'reload'],
  components: {},
  created() {},
  mounted() {},
  data() {
    return {
      filter,
      visible: {
        大会会议: false,
        关于CSGCT: false,
        大会活动: false,
        用户中心: false,
        注册参会: false,
        展览赞助: false,
        日常活动: false,
      },
    }
  },
  computed: {
    ...mapState({
      static_img_url: (state) => state.static_img_url,
      user_key: (state) => state.user_key,
      contentNav: (state) => state.contentNav,
      activityDetail: (state) => state.activityDetail,
      language: (state) => state.language,
      channelDiscountRate: (state) => state.channelDiscountRate,
      asgctDiscountRate: (state) => state.asgctDiscountRate,
    }),
    navPosition() {
      return function(ids) {
        let arr = this.contentNav.filter((item) => ids.includes(item.id))
        return arr
      }
    },
    navPosition3() {
      let arr = this.contentNav.filter((item) => [291].includes(item.id))
      return arr
    },
    navPosition4() {
      let arr = this.contentNav.filter((item) => [294, 295, 296].includes(item.id))
      return arr
    },
  },
  methods: {
    handleChangeVisible(value, name) {
      this.visible[name] = value
      if (value) {
        this.globalInsertRecords({
          contentId: 0,
          contentType: 81,
          viewType: 2,
          keyword: name,
        })
      }
    },
    /**
     * 处理路由变化
     *
     * @param name 路由名称
     */
    handleChangeRoute(name, query) {
      // 判断name是否包含contentPage
      if (name.indexOf('contentPage') > -1) {
        let content_id = name.split('contentPage')[1] - 0
        let index = this.contentNav.findIndex((item) => item.id == content_id)
        if (index > -1) {
          this.globalInsertRecords({
            contentId: content_id,
            contentType: 81,
            viewType: 1,
            keyword: this.contentNav[index].pageName,
          })
        }
        this.$router.push({ name: 'exhibitionDesc', params: { id: content_id } })
        return
      }
      this.globalInsertRecords({
        contentId: 0,
        contentType: 81,
        viewType: 1,
        keyword: name,
      })
      switch (name) {
        case 'quit':
          this.exitlogin()
          break
        case 'toplist':
          window.open('https://vb100.vbdata.cn/Index/list', '_blank')
          break
        case 'login':
          this.login()
          break
        case 'newsList2':
          this.$router.push({ name: 'newsList', query: { type: 2 } })
          break
        case 'previousMeetings':
          this.$router.replace({ name: 'previousTheme' })
          break
        default:
          this.$router.push({ name })
      }
    },
    async exitlogin() {
      let res = await Aexitlogin()
      if (res.code == 0) {
        this.$store.commit('updateUserKey', '')
        this.$store.commit('updateUser', '')
        this.$store.commit('setUUserId', '')
        this.$Message.success(this.language == 'zh' ? '退出登录成功！' : 'Log out successfully!')
        this.$router.push({ name: 'index' })
        this.reload()
      } else {
        this.$Message.error(filter.dealLanguage(res.msg, res.enMsg || res.msg))
      }
    },
    handleChangeLanguage() {
      let newLanguage = this.language === 'zh' ? 'en' : 'zh'
      // this.$store.commit('setLanguage', newLanguage)
      // localStorage.setItem('vbefLanguage', newLanguage)

      let routerQuery = this.$route.query
      if (newLanguage == 'en') {
        delete routerQuery.language
      } else {
        routerQuery.language = newLanguage
      }

      this.$store.commit('updateUserKey', '')
      const { href } = this.$router.resolve({ path: this.$route.path, query: routerQuery })
      location.href = href

      // this.$router.resolve({ path: this.$route.path, query: routerQuery })
      // this.$nextTick(() => {
      //   this.reload()
      // })
    },
  },
}
</script>
<style lang='stylus' scoped>
.hero-overlay
  width 100%
  height 32px
  background #FFF3F3
  font-weight 400
  font-size 14px
  color #C8161D
  line-height 32px
  text-align center
.header-content
  width 1200px
  height 64px
  margin 0 auto
  display flex
  align-items center
  justify-content space-between
  .header-left
    display flex
    align-items center
  .header-logo
    font-size 0
    display flex
    align-items center
    img
      width auto
      height 50px
      cursor pointer
  .header-str
    margin-left 6px
    height 36px
    .p1
      font-size 16px
      color #C8161D
      line-height 18px
    .p2
      color #C8161D
      font-size 12px
      line-height 1
      margin-top 5px
  .header-navigation
    display flex
    align-items center
    font-size 14px
    gap 30px
    .lang-item
      width 41px
      color #333333
      cursor pointer
      display flex
      align-items center
      justify-content center
      position relative
      transition all 0.3s
      span
        transition all 0.2s
        font-size 14px
        &.active
          font-size 15px
          color #C8161D
      &:hover
        color #C8161D
    .nav-item
      color #333333
      cursor pointer
      display flex
      align-items center
      justify-content center
      transition all 0.3s
      font-size 14px
      position relative
      span
        &+i
          font-size 14px
          transition all 0.3s
          margin-left 4px
        &.active
          color #C8161D
      &:hover, &.active
        color #C8161D
      &.visible
        color #C8161D
        i
          transform rotate(180deg)
    &.en
      gap: 15px;
      .nav-item
        font-size 13px
        span
          &+i
            font-size 12px
            margin-left 2px
  >>> .ivu-dropdown
    .ivu-select-dropdown
      padding 20px 0 5px
      margin 0
      border-radius 0
      box-shadow none
      background none
      .ivu-dropdown-menu
        box-shadow 0 1px 6px rgba(0, 0, 0, 0.2)
        background-color #fff
        padding 5px 0
        .ivu-dropdown-item
          color #333333
</style>
